package com.havn.app.core.settings

import kotlinx.browser.window

private const val KioskPinKey = "havn.kiosk.pin"

actual fun loadStoredHavnKioskPin(): String? =
    window.localStorage.getItem(KioskPinKey)

actual fun storeHavnKioskPin(pin: String) {
    window.localStorage.setItem(KioskPinKey, pin)
}
